var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotifications = function SvgNotifications(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 36"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M25.4 26.9c0-.7-.6-1.3-1.3-1.3-1 0-1.8-.8-1.8-1.8v-6.9c0-4.5-3.7-8.2-8.2-8.2s-8.2 3.7-8.2 8.2v6.9c0 1-.8 1.8-1.8 1.8-.7 0-1.3.6-1.3 1.3v.3h22.7v-.3h-.1zm2.6 0v.5c0 1.3-1.1 2.4-2.4 2.4H2.4c-1.3 0-2.4-1.1-2.4-2.4v-.5C0 25 1.4 23.4 3.2 23v-6.2C3.2 10.9 8 6 14 6s10.8 4.9 10.8 10.9V23c1.8.4 3.2 2 3.2 3.9zM9 30.6h2.6c0 1.3 1.1 2.4 2.4 2.4s2.4-1.1 2.4-2.4H19c0 2.8-2.2 5-5 5s-5-2.2-5-5z",
    clipRule: "evenodd"
  })));
};
export default SvgNotifications;